import {strings} from "./strings/strings";
import {AxiosRequestConfig} from "axios";

export const Routes = {
    emtplQuotationRoot: '/emtpl',
    emtplSuccessfulQuotationPath: '/emtpl/quotation/successful',
    emtplUnsuccessfulQuotationPath: '/emtpl/payment/unsuccessful',
    travelQuotationRoot: '/travel',
    travelSuccessfulQuotationPath: '/travel/quotation/successful',
    travelUnsuccessfulQuotationPath: '/travel/payment/unsuccessful',
    greenQuotationRoot: '/green-card',
    greenSuccessfulQuotationPath: '/green-card/quotation/successful',
    greenUnsuccessfulQuotationPath: '/green-card/payment/unsuccessful'
}

export default {
    API_URL: process.env.REACT_APP_API_BASE_URL,
    skipValidation: true,
    verification: {
        successfulQuotationURL: process.env.PUBLIC_URL + Routes.emtplSuccessfulQuotationPath,
        unsuccessfulPaymentURL: process.env.PUBLIC_URL + Routes.emtplUnsuccessfulQuotationPath,
        travelSuccessfulQuotationURL: process.env.PUBLIC_URL + Routes.travelSuccessfulQuotationPath,
        travelUnsuccessfulPaymentURL: process.env.PUBLIC_URL + Routes.travelUnsuccessfulQuotationPath,
        greenSuccessfulQuotationURL: process.env.PUBLIC_URL + Routes.greenSuccessfulQuotationPath,
        greenUnsuccessfulPaymentURL: process.env.PUBLIC_URL + Routes.greenUnsuccessfulQuotationPath,
        resendTimeout: 120
    },
    idleTimeoutMillisecond: 1000 * 60 * 15, //15 min
    timeoutDialogMillisecond: 1000 * 60 * 10, //10 min
    ARX_URL: strings.refs.link,
    technicalWorkUrl: process.env.PUBLIC_URL + '/technical',
    technicalGreednCardWorkUrl: process.env.PUBLIC_URL + '/technical-gree-card',
    unavailablePageUrl: process.env.PUBLIC_URL + '/no-product',
    mainPageUrl: process.env.PUBLIC_URL,
    ARX_CONTACT_URL: strings.refs.kontakty,
    forbiddenCountries: [{code: 'KP', name: strings.China}, {code: 'IR', name: strings.Iran}],
    LOG_SERVER: process.env.REACT_APP_LOG_SERVER,
    CREATE_LEAD_API_URL: process.env.REACT_APP_CREATE_LEAD_API_URL,
    leadCreateApiVersion: process.env.REACT_APP_LEAD_CREATE_APIVERSION,
    leadCreatePartnerToken: process.env.REACT_APP_LEAD_CREATE_PARTNERTOKEN,
}

export const axiosConfig: AxiosRequestConfig = {
    withCredentials: true
};
